class LMWithdrawalForm {
  constructor(form) {
    this.form = form;
    this.button = form.querySelector('[type="submit"]');
    this.status = form.parentElement.querySelector('[data-lm-withdrawal-status]');
    this.responseFrame = form.parentElement.querySelector('iframe[name="lm-withdrawal-response"]');
    this.timeout = null;
    this.onMessage = this.onMessage.bind(this);
    window.addEventListener('message', this.onMessage);
    form.addEventListener('submit', () => this.onSubmit());
  }
  onSubmit() {
    this.button.disabled = true;
     this.button.setAttribute('aria-busy', 'true');
     this.showStatus('Dein Widerruf wird sicher übermittelt …', 'pending');
     this.timeout = window.setTimeout(() => {
     this.resetButton();
     this.form.reset();
     this.showStatus(
        'Dein Widerruf wurde übermittelt. Bitte prüfe jetzt dein E-Mail-Postfach und gegebenenfalls den Spamordner. Nur die Eingangsbestätigung per E-Mail bestätigt den erfolgreichen Eingang.',
       'success'
      );
       this.status.focus();
    }, 8000);
  }
  onMessage(event) {
   if (
  event.origin !== 'https://script.google.com' &&
  !event.origin.endsWith('.googleusercontent.com')
  ) return;
    if (!event.data || event.data.source !== 'lm-withdrawal') return;
    window.clearTimeout(this.timeout);
    this.resetButton();
    if (event.data.status === 'success') {
      this.form.reset();
      this.showStatus('Dein Widerruf ist eingegangen. Die Eingangsbestätigung wurde an deine E-Mail-Adresse gesendet.', 'success');
      this.status.focus();
      return;
    }
    this.showStatus(event.data.message || 'Die Übermittlung ist fehlgeschlagen. Bitte versuche es erneut oder widerrufe per E-Mail.', 'error');
    this.status.focus();
  }
  resetButton() {
    this.button.disabled = false;
    this.button.removeAttribute('aria-busy');
  }
  showStatus(message, type) {
    this.status.textContent = message;
    this.status.hidden = false;
    this.status.className = 'lm-withdrawal__status';
    if (type === 'success') this.status.classList.add('lm-withdrawal__status--success');
    if (type === 'error') this.status.classList.add('lm-withdrawal__status--error');
  }
}
document.querySelectorAll('[data-lm-withdrawal-form]').forEach((form) => new LMWithdrawalForm(form));

